import { useState, useEffect } from 'react';
import axios from 'axios';

export const useLeaveGroups = () => {
  const [leaveGroups, setLeaveGroups] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    axios.get(`${process.env.REACT_APP_API_URL}/api/leave/groups`, {
      headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
    })
      .then(r => setLeaveGroups(r.data || []))
      .catch(() => {})
      .finally(() => setLoading(false));
  }, []);

  return { leaveGroups, loading };
};
